import { Vue, Component } from "vue-property-decorator";

@Component
export default class SettingsHelp extends Vue {
    public readonly Title = this.$alt.config.about.title;
    public readonly Version = this.$alt.config.about.version;
    public readonly SupportEmail = this.$alt.config.about.supportEmail;
    public readonly SupportTg = this.$alt.config.about.supportTg;
    public readonly DocsVisible = this.$alt.config.common.documentationEnabled;
    public readonly DocsUrl = this.$alt.config.url.docs;

    public get logoSrc(): string {
        const dir = this.$alt.config.common.logoDirectory;
        return require(`@/assets/images/${dir}/logo_small.png`);
    }
}
